import React, { useState } from 'react';
import { motion } from 'framer-motion';
export function ContactForm() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const customEase = [0.16, 1, 0.3, 1];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate form submission
    console.log('Form submitted');
    setIsSubmitted(true);
  };
  return <section id="contact-form" className="py-24 md:py-32 bg-cream texture-grain relative" data-id="element-19">
      <div className="max-w-[90rem] mx-auto px-6 lg:px-12" data-id="element-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-21">
          {/* Left Column - Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: customEase
        }} data-id="element-22">
            <h2 className="font-serif text-5xl md:text-6xl font-light text-ink mb-6" data-id="element-23">
              Get in Touch
            </h2>
            <p className="text-stone font-sans text-lg mb-12 max-w-md" data-id="element-24">
              Whether you'd like to enquire about a private masterclass, discuss
              makeup services, or simply ask a question — we'd love to hear from
              you.
            </p>

            <div className="space-y-6 text-ink font-sans" data-id="element-25">
              <div data-id="element-26">
                <div className="text-xs uppercase tracking-[0.2em] text-stone mb-1" data-id="element-27">
                  Email
                </div>
                <a href="mailto:hello@themakeupatelier.com.au" className="text-lg hover:text-copper transition-colors" data-id="element-28">
                  hello@themakeupatelier.com.au
                </a>
              </div>
              <div data-id="element-29">
                <div className="text-xs uppercase tracking-[0.2em] text-stone mb-1" data-id="element-30">
                  Location
                </div>
                <div className="text-lg" data-id="element-31">East Coast, Australia</div>
              </div>
              <div data-id="element-32">
                <div className="text-xs uppercase tracking-[0.2em] text-stone mb-1" data-id="element-33">
                  Response Time
                </div>
                <div className="text-lg" data-id="element-34">
                  We typically respond within 24 hours
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: customEase
        }} data-id="element-35">
            {isSubmitted ? <div className="h-full flex flex-col items-center justify-center text-center p-12 bg-white border border-cream-dark" data-id="element-36">
                <div className="w-16 h-16 rounded-full bg-cream flex items-center justify-center mb-6 text-copper" data-id="element-37">
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-38">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M5 13l4 4L19 7" data-id="element-39" />
                  </svg>
                </div>
                <h3 className="font-serif text-3xl text-ink mb-4" data-id="element-40">
                  Thank you for your enquiry.
                </h3>
                <p className="text-stone" data-id="element-41">We'll be in touch within 24 hours.</p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-42">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-43">
                  <div data-id="element-44">
                    <label htmlFor="name" className="sr-only" data-id="element-45">
                      Name
                    </label>
                    <input type="text" id="name" required placeholder="Your Name" className="w-full bg-white border border-cream-dark px-4 py-3 font-sans text-ink focus:border-copper focus:outline-none transition-colors placeholder:text-stone/60" data-id="element-46" />
                  </div>
                  <div data-id="element-47">
                    <label htmlFor="email" className="sr-only" data-id="element-48">
                      Email
                    </label>
                    <input type="email" id="email" required placeholder="Email Address" className="w-full bg-white border border-cream-dark px-4 py-3 font-sans text-ink focus:border-copper focus:outline-none transition-colors placeholder:text-stone/60" data-id="element-49" />
                  </div>
                </div>

                <div className="relative" data-id="element-50">
                  <label htmlFor="subject" className="sr-only" data-id="element-51">
                    Subject
                  </label>
                  <select id="subject" required className="w-full bg-white border border-cream-dark px-4 py-3 font-sans text-ink focus:border-copper focus:outline-none transition-colors appearance-none pr-10" defaultValue="" data-id="element-52">
                    <option value="" disabled data-id="element-53">
                      What are you enquiring about?
                    </option>
                    <option value="masterclass" data-id="element-54">Masterclass Booking</option>
                    <option value="private" data-id="element-55">Private Class Enquiry</option>
                    <option value="services" data-id="element-56">Makeup Services</option>
                    <option value="voucher" data-id="element-57">Gift Voucher</option>
                    <option value="general" data-id="element-58">General Question</option>
                  </select>
                  <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-stone" data-id="element-59">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-60">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-61"></path>
                    </svg>
                  </div>
                </div>

                <div data-id="element-62">
                  <label htmlFor="message" className="sr-only" data-id="element-63">
                    Message
                  </label>
                  <textarea id="message" rows={4} placeholder="Your Message" className="w-full bg-white border border-cream-dark px-4 py-3 font-sans text-ink focus:border-copper focus:outline-none transition-colors placeholder:text-stone/60 resize-y" data-id="element-64"></textarea>
                </div>

                <button type="submit" className="bg-ink text-parchment px-10 py-4 text-xs uppercase tracking-[0.2em] hover:bg-espresso transition-colors w-full md:w-auto" data-id="element-65">
                  Send Enquiry
                </button>
              </form>}
          </motion.div>
        </div>
      </div>
    </section>;
}